
import React, { useEffect, useRef, useState } from 'react';
import TakeLookTopSection from '../../../components/TakeALook/TakeLookTopSection';
import TakeLookSubHeading from '../../../components/TakeALook/TakeLookSubHeading';

// Social icons (same paths you used)
import InstagramLogo from '../../../assets/img/customer-service-center/Instagram.png';
import FacebookLogo from '../../../assets/img/customer-service-center/Facebook.png';
import KakaoLogo from '../../../assets/img/customer-service-center/Kakao.png';

// 2) Kakao JS Key (use env in production)
// const KAKAO_KEY = '14be42c9a3c3c7f2f24153d25810ba11';
const KAKAO_KEY = 'a13a559fb1f5b864d81b8a4a48c07c0c';

// 3) Helper: ensure Kakao imageUrl is ABSOLUTE (Kakao requires public https)
const getAbsoluteUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path; // already absolute
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  // if it starts with "/", prefix origin; else join as /path
  return path.startsWith('/') ? `${origin}${path}` : `${origin}/${path}`;
};

const TakeLookPCFullView = () => {
  // 4) Local state
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isShareOpen, setIsShareOpen] = useState(false);

  // Separate refs so click-outside works for both desktop & mobile popups
  const shareDesktopRef = useRef(null);
  const shareMobileRef = useRef(null);

  // 5) Gallery images
  const images = [
    { main: '/images/TakeLook/02_Sky Hall  VIP/하늘관VIP_01.jpg', thumbnail: '/images/TakeLook/02_Sky Hall  VIP/하늘관VIP_01.jpg' },
    { main: '/images/TakeLook/02_Sky Hall  VIP/하늘관VIP_02.jpg', thumbnail: '/images/TakeLook/02_Sky Hall  VIP/하늘관VIP_02.jpg' },
    { main: '/images/TakeLook/02_Sky Hall  VIP/하늘관VIP_03.jpg', thumbnail: '/images/TakeLook/02_Sky Hall  VIP/하늘관VIP_03.jpg' },
    { main: '/images/TakeLook/02_Sky Hall  VIP/하늘관VIP_04.jpg', thumbnail: '/images/TakeLook/02_Sky Hall  VIP/하늘관VIP_04.jpg' },
  ];

  // 6) Load & init Kakao SDK (once)
  useEffect(() => {
    if (typeof window !== 'undefined' && window.Kakao) {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(KAKAO_KEY);
      }
      return; // already available
    }

    if (!document.getElementById('kakao-sdk')) {
      const script = document.createElement('script');
      script.id = 'kakao-sdk';
      script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
      script.async = true;
      script.onload = () => {
        if (window.Kakao && !window.Kakao.isInitialized()) {
          window.Kakao.init(KAKAO_KEY);
        }
      };
      document.body.appendChild(script);
    }
  }, []);

  // 7) Close share popup when clicking outside or pressing ESC
  useEffect(() => {
    const onClickOutside = (e) => {
      const d = shareDesktopRef.current;
      const m = shareMobileRef.current;
      const clickedInsideDesktop = d && d.contains(e.target);
      const clickedInsideMobile = m && m.contains(e.target);
      if (!clickedInsideDesktop && !clickedInsideMobile) {
        setIsShareOpen(false);
      }
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') setIsShareOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

  // 8) Gallery handlers
  const handlePrevious = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };
  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };
  const handleThumbnailClick = (index) => setCurrentImageIndex(index);

  // 9) Popup toggle
  const toggleShare = () => setIsShareOpen((v) => !v);

  // 10) Open share targets (works on desktop + mobile)
  const handleShareClick = (platform) => {
    const currentUrl = window.location.href;

    if (platform === 'facebook') {
      // Facebook web sharer — works everywhere
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
        '_blank',
        'width=600,height=500'
      );
    }

    if (platform === 'instagram') {
      // Instagram has no official web share; open IG (user can paste)
      // If you have a brand profile URL, open that instead.
      window.open('https://www.instagram.com/', '_blank', 'width=1200,height=800');
    }

    if (platform === 'kakao') {
      // Prefer Kakao Link (shows Talk share UI; on desktop it may show QR workflow).
      const imageUrl = getAbsoluteUrl(images[currentImageIndex].main);

      const tryFallback = () => {
        // Reliable web fallback: share to Kakao Story (works on desktop web)
        window.open(
          `https://story.kakao.com/share?url=${encodeURIComponent(currentUrl)}`,
          '_blank',
          'width=600,height=600'
        );
      };

      try {
        if (window.Kakao && window.Kakao.isInitialized()) {
          window.Kakao.Link.sendDefault({
            objectType: 'feed',
            content: {
              title: document.title || 'Take a Look',
              description: '하늘관 VIP 공유하기',
              imageUrl,
              link: {
                mobileWebUrl: currentUrl,
                webUrl: currentUrl,
              },
            },
            buttons: [
              {
                title: '웹에서 보기',
                link: {
                  mobileWebUrl: currentUrl,
                  webUrl: currentUrl,
                },
              },
            ],
          });
        } else {
          tryFallback();
        }
      } catch (e) {
        tryFallback();
      }
    }

    setIsShareOpen(false);
  };

  // 11) Render
  return (
    <div className="announcement-list-page take-look-info-page sky-hall-vip-page">
      <TakeLookTopSection />

      <main className="main-content">
        <TakeLookSubHeading heading="하늘관 VIP" />

        <div className="take-look-page-content">
          <div className="full-view-content">

            {/* Gallery (Desktop/Tablet) */}
            <div className="sky-hall-special-room-gallery">
              <div className="sky-hall-special-room-gallery-main-view">
                <img
                  src={images[currentImageIndex].main}
                  alt="하늘관 특별실 큰 이미지"
                  className="sky-hall-special-room-main-image"
                />
                <button
                  className="sky-hall-special-room-gallery-arrow sky-hall-special-room-gallery-arrow-prev"
                  onClick={handlePrevious}
                  aria-label="이전 이미지"
                >
                  <img src="/images/Main/arrow-right-white.png" alt="" />
                </button>
                <button
                  className="sky-hall-special-room-gallery-arrow sky-hall-special-room-gallery-arrow-next"
                  onClick={handleNext}
                  aria-label="다음 이미지"
                >
                  <img src="/images/Main/arrow-left-white.png" alt="" />
                </button>
              </div>

              {/* Thumbnails + Share (Desktop) */}
              <div className="sky-hall-special-room-gallery-thumbnails-container">
                <div className="sky-hall-special-room-gallery-thumbnails">
                  {images.map((image, index) => (
                    <a
                      key={index}
                      href="#"
                      className={`sky-hall-special-room-thumbnail-item ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleThumbnailClick(index);
                      }}
                      aria-current={index === currentImageIndex ? 'true' : 'false'}
                    >
                      <img src={image.thumbnail} alt={`썸네일 ${index + 1}`} />
                    </a>
                  ))}
                </div>

                {/* Share Section (Desktop) */}
                <div className="full-view-share-section" ref={shareDesktopRef}>
                  <div className="share-container">
                    <button
                      className="full-view-share-button"
                      aria-haspopup="true"
                      aria-expanded={isShareOpen}
                      aria-controls="share-popup-desktop"
                      onClick={toggleShare}
                    >
                      <span className="share-text">SNS 공유</span>
                      <img src="/images/TakeLook/share.png" alt="공유하기" className="logo" />
                    </button>

                    {isShareOpen && (
                      <div
                        id="share-popup-desktop"
                        className="share-popup"
                        role="dialog"
                        aria-label="공유하기"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="popup-title">공유하기</div>
                        <div className="popup-buttons">
                          <button
                            type="button"
                            className="social-btn"
                            onClick={() => handleShareClick('instagram')}
                            aria-label="Instagram으로 공유하기"
                            title="Instagram으로 공유하기"
                          >
                            <img src={InstagramLogo} alt="Instagram" className="logo" />
                          </button>

                          <button
                            type="button"
                            className="social-btn"
                            onClick={() => handleShareClick('facebook')}
                            aria-label="Facebook으로 공유하기"
                            title="Facebook으로 공유하기"
                          >
                            <img src={FacebookLogo} alt="Facebook" className="logo" />
                          </button>

                          <button
                            type="button"
                            className="social-btn"
                            onClick={() => handleShareClick('kakao')}
                            aria-label="KakaoTalk으로 공유하기"
                            title="KakaoTalk으로 공유하기"
                          >
                            <img src={KakaoLogo} alt="KakaoTalk" className="logo" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile vertical images + Share */}
            <div className="mobile-take-look-main-container">
              <div className="mobile-take-look-main-image-wrapper">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {images.map((image, index) => (
                    <img
                      key={index}
                      src={image.main}
                      alt={`Sky Hall VIP ${index + 1}`}
                      className="mobile-take-look-main-image"
                      style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                    />
                  ))}
                </div>
              </div>

              <div className="mobile-take-look-share-section" ref={shareMobileRef}>
                <div className="share-container">
                  <button
                    className="mobile-take-look-main-share-btn"
                    aria-haspopup="true"
                    aria-expanded={isShareOpen}
                    aria-controls="share-popup-mobile"
                    aria-label="공유하기"
                    onClick={toggleShare}
                  >
                    <span className="share-text">SNS 공유</span>
                    {/* <img src="/images/TakeLook/share-mo.png" alt="공유하기" />/ */}
                    <img src="/images/TakeLook/share.png" alt="공유하기" className="logo" />
                  </button>

                  {isShareOpen && (
                    <div
                      id="share-popup-mobile"
                      className="share-popup"
                      role="dialog"
                      aria-label="공유하기"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="popup-title">공유하기</div>
                      <div className="popup-buttons">
                        <button
                          type="button"
                          className="social-btn"
                          onClick={() => handleShareClick('instagram')}
                          aria-label="Instagram으로 공유하기"
                        >
                          <img src={InstagramLogo} alt="Instagram" className="logo" />
                        </button>

                        <button
                          type="button"
                          className="social-btn"
                          onClick={() => handleShareClick('facebook')}
                          aria-label="Facebook으로 공유하기"
                        >
                          <img src={FacebookLogo} alt="Facebook" className="logo" />
                        </button>

                        <button
                          type="button"
                          className="social-btn"
                          onClick={() => handleShareClick('kakao')}
                          aria-label="KakaoTalk으로 공유하기"
                        >
                          <img src={KakaoLogo} alt="KakaoTalk" className="logo" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};

export default TakeLookPCFullView;

